import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { RewardTrackBanner } from '@/components/Shop/RewardTrackBanner/RewardTrackBanner';
import { ShopTitle } from '@/components/Shop/ui/ShopUi';
import { useAppSelector } from '@/redux/store';

import ArenaOffers from './ArenaOffers/ArenaOffers';
import { VipMarket } from './VipMarket/VipMarket';

/** "Offers" tab of the shop: Reward Track, VIP offer and arena offers. */
const OffersMarket: FC = () => {
  const { t } = useTranslation();
  const vipData = useAppSelector((state) => state.user.vip);
  // Same conditions as the cards themselves (Bingo card hides when over)
  const hasArenaOffers = useAppSelector(
    (state) =>
      !!state.shop.arenaOffers.length ||
      (!!state.shop.bingoEvent && state.shop.bingoEvent.endsInSeconds > 0),
  );

  return (
    <div className="flex flex-col w-full px-4 pt-4 pb-6 gap-6">
      <RewardTrackBanner />
      {vipData && (
        <section className="flex flex-col gap-4">
          <ShopTitle className="!text-left">{t('VIP Offer')}</ShopTitle>
          <VipMarket />
        </section>
      )}
      {hasArenaOffers && (
        <section className="flex flex-col gap-4">
          <ShopTitle className="!text-left">{t('Arena Offers')}</ShopTitle>
          <ArenaOffers />
        </section>
      )}
    </div>
  );
};

export { OffersMarket };
